export const GET_CASE_DETAILS_REQUEST = "ADMIN_CASE_DETAILS/GET_CASE_DETAILS_REQUEST";
export const GET_CASE_DETAILS_SUCCESS = "ADMIN_CASE_DETAILS/GET_CASE_DETAILS_SUCCESS";
export const GET_CASE_DETAILS_FAILURE = "ADMIN_CASE_DETAILS/GET_CASE_DETAILS_FAILURE";

export const GET_AVAILABLE_UNITS_REQUEST = "ADMIN_CASE_DETAILS/GET_AVAILABLE_UNITS_REQUEST";
export const GET_AVAILABLE_UNITS_SUCCESS = "ADMIN_CASE_DETAILS/GET_AVAILABLE_UNITS_SUCCESS";
export const GET_AVAILABLE_UNITS_FAILURE = "ADMIN_CASE_DETAILS/GET_AVAILABLE_UNITS_FAILURE";

export const EDIT_CASE_DETAILS_REQUEST = "ADMIN_CASE_DETAILS/EDIT_CASE_DETAILS_REQUEST";
export const EDIT_CASE_DETAILS_SUCCESS = "ADMIN_CASE_DETAILS/EDIT_CASE_DETAILS_SUCCESS";
export const EDIT_CASE_DETAILS_FAILURE = "ADMIN_CASE_DETAILS/EDIT_CASE_DETAILS_FAILURE";

export const CANCEL_CASE_REQUEST = "ADMIN_CASE_DETAILS/CANCEL_CASE_REQUEST";
export const CANCEL_CASE_SUCCESS = "ADMIN_CASE_DETAILS/CANCEL_CASE_SUCCESS";
export const CANCEL_CASE_FAILURE = "ADMIN_CASE_DETAILS/CANCEL_CASE_FAILURE";

export const CONVERT_CASE_REQUEST = "ADMIN_CASE_DETAILS/CONVERT_CASE_REQUEST";
export const CONVERT_CASE_SUCCESS = "ADMIN_CASE_DETAILS/CONVERT_CASE_SUCCESS";
export const CONVERT_CASE_FAILURE = "ADMIN_CASE_DETAILS/CONVERT_CASE_FAILURE";

export const EDIT_ADMIN_CASE_NOTES_REQUEST = "EDIT_ADMIN_CASE_NOTES_REQUEST";
export const EDIT_ADMIN_CASE_NOTES_SUCCESS = "EDIT_ADMIN_CASE_NOTES_SUCCESS";
export const EDIT_ADMIN_CASE_NOTES_FAILURE = "EDIT_ADMIN_CASE_NOTES_FAILURE";

export const CHANGE_CASE_STATUS_REQUEST = "CHANGE_CASE_STATUS_REQUEST";
export const CHANGE_CASE_STATUS_SUCCESS = "CHANGE_CASE_STATUS_SUCCESS";
export const CHANGE_CASE_STATUS_FAILURE = "CHANGE_CASE_STATUS_FAILURE";


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AdminCaseDetails/constants.js